import { css } from 'styled-components';
import { SpacingName } from '../../../theme/constants';
import { getSpacing, rgba } from '../../../theme/utils';
export const base = _ref => {
  let {
    theme
  } = _ref;
  return css(["background-color:", ";position:absolute;top:0;left:0;right:0;bottom:0;z-index:", ";display:flex;align-items:flex-end;justify-content:center;"], rgba(theme.palettes.neutrals.lightest, 0.7), theme.zIndex.inpage);
};
export const box = _ref2 => {
  let {
    theme
  } = _ref2;
  return css(["background-color:", ";border:1px solid ", ";", ";flex:1;max-width:40rem;box-shadow:0 4px 8px 0 ", ";"], theme.palettes.neutrals.lightest, theme.palettes.neutrals.light, getSpacing.padding(theme, SpacingName.MEDIUM), rgba(theme.palettes.neutrals.darkest, 0.5));
};
//# sourceMappingURL=Confirm.style.js.map